var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftIconGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pre icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M15.8307 10.75C16.2449 10.75 16.5807 10.4142 16.5807 10C16.5807 9.58579 16.2449 9.25 15.8307 9.25V10.75ZM3.63373 9.46967C3.34084 9.76256 3.34084 10.2374 3.63373 10.5303L8.4067 15.3033C8.6996 15.5962 9.17447 15.5962 9.46736 15.3033C9.76026 15.0104 9.76026 14.5355 9.46736 14.2426L5.22472 10L9.46736 5.75736C9.76026 5.46447 9.76026 4.98959 9.46736 4.6967C9.17447 4.40381 8.6996 4.40381 8.4067 4.6967L3.63373 9.46967ZM15.8307 9.25H4.16406V10.75H15.8307V9.25Z",
    fill: "#1DA687"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIconGreen);
export default __webpack_public_path__ + "static/media/left-icon-green.cfef214d855ea4360958087d3c681787.svg";
export { ForwardRef as ReactComponent };